import React from 'react';
import HighlightCard from './HighlightCard';

export default function HighlightsList({ highlights }) {
  if (!highlights || highlights.length === 0) return null;
  return (
    <section style={styles.section}>
      <div style={styles.inner}>
        <span style={styles.eyebrow}>Das erwartet Sie</span>
        <h2 style={styles.heading}>Warum Camping Spirkenhof?</h2>
        <div style={styles.grid}>
          {highlights.map(h => (
            <HighlightCard key={h.id} icon={h.icon} title={h.title} text={h.text} />
          ))}
        </div>
      </div>
    </section>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  section: {
    backgroundColor: '#ffffff',
    padding: '5rem 1.5rem',
    borderTop: '1px solid #e5e7eb',
  },
  inner: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: {
    color: '#111827',
    fontFamily: F,
    fontSize: 'clamp(1.5rem,4vw,2.2rem)',
    fontWeight: '700',
    marginTop: '0.4rem',
    marginBottom: '2.5rem',
    letterSpacing: '-0.3px',
  },
  grid: { display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'center' },
};
